import { SIM_BUILDER_API_END_POINT } from "../Config";
import RequestService, { HttpMethods } from "../utils/requestService";
import authFetch from "../utils/authFetch";

const DashboardItemService = () => {
  return Object.freeze({
    getRangeBySim: async (simId, token) => {
      const options = RequestService.makeRequest(HttpMethods.GET, token);
      const result = await authFetch(
        `${SIM_BUILDER_API_END_POINT}/dashboard-items/${simId}`,
        options
      );
      const response = await result.json();
      return response;
    },
    addOrUpdateRange: async (dto, token) => {
      const options = RequestService.makeRequest(HttpMethods.POST, token);
      options.body = JSON.stringify(dto);
      const result = await authFetch(
        `${SIM_BUILDER_API_END_POINT}/dashboard-items`,
        options
      );
      const response = await result.json();
      return response;
    },
    deleteBySim: async (simId, token) => {
      const options = RequestService.makeRequest(HttpMethods.DELETE, token);
      const result = await authFetch(
        `${SIM_BUILDER_API_END_POINT}/dashboard-items/${simId}`,
        options
      );
      const response = await result.json();
      return response;
    },
  });
};

export default DashboardItemService;
